import React from 'react';
import loadable from '@loadable/component';

const AboutUs = loadable(() => import('../components/AboutUs/AboutUs'));

const AboutUsPage = () => (
    <AboutUs />
)

export default AboutUsPage;